// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__1vPiT","infomat":"Heading_infomat__a3QuG"};